import { NJText } from '@engie-group/fluid-design-system-react';
import { RatioSectionHeader } from './RatioSectionHeader';
import { PerfTable } from './PerfTable';
import type { RatioTable } from './types';

interface Props {
  applied: boolean;
  ratios: RatioTable;
}

export function ProjectRatiosCard(p: Props) {
  return (
    <section className="pcv3-ratios-card" aria-label="Résultats du calcul des ratios">
      <RatioSectionHeader number={3} title="Ratios adaptés au climat du projet" icon="table_chart" />
      <div className="pcv3-ratios-body">
        {!p.applied ? <NJText>Les ratios adaptés au climat du projet s’afficheront ici après le calcul.</NJText> : <>
          <PerfTable calculated value={p.ratios} />
        </>}
      </div>
    </section>
  );
}
